/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ValidationSeverity } from "abreact/form/ValidationIssue";
export class FeedbackUtils {
  /**
   * Returns the highest severity from a list of validation issues.
   */
  static getHighestSeverity(severities) {
    let highestSeverity;
    severities.forEach(severity => {
      switch (severity) {
        case ValidationSeverity.WARNING:
          if (highestSeverity === undefined) {
            highestSeverity = ValidationSeverity.WARNING;
          }
          break;
        case ValidationSeverity.ERROR:
          if (highestSeverity === undefined || highestSeverity === ValidationSeverity.WARNING) {
            highestSeverity = ValidationSeverity.ERROR;
          }
          break;
        case ValidationSeverity.FATAL_ERROR:
          if (highestSeverity !== ValidationSeverity.INTERNAL_ERROR) {
            highestSeverity = ValidationSeverity.FATAL_ERROR;
          }
          break;
        case ValidationSeverity.INTERNAL_ERROR:
          highestSeverity = ValidationSeverity.INTERNAL_ERROR;
          break;
      }
    });
    return highestSeverity;
  }
  static getValidationSeverityIconName(validationSeverity) {
    switch (validationSeverity) {
      case ValidationSeverity.WARNING:
        return "absdk:warning";
      case ValidationSeverity.ERROR:
        return "absdk:error";
      // TODO: AndyA/EBator: add an AbSDK icon for errors that don't block saving
      case ValidationSeverity.FATAL_ERROR:
        return "absdk:error";
      case ValidationSeverity.INTERNAL_ERROR:
        return "absdk:error";
      // TODO: AndyA/EBator: add an AbSDK icon for internal errors
      default:
        // Ensure that all enum values are handled
        // See: https://confluence.abinitio.com/display/FED/Ensure+switch+case+statement+for+every+enum+value
        const unknownSeverity = validationSeverity;
        throw new Error(`Unrecognized validation severity ${unknownSeverity} in getValidationSeverityIconName`);
    }
  }
}
//# sourceMappingURL=FeedbackUtils.js.map
